import './typing-chat.scss';

export function TypingChat() {
  return (
    <div className="chat-container">
      <div className="dot" />
      <div className="dot" />
      <div className="dot" />
    </div>
  );
}
